import { render } from "./SelectInputFilter.vue?vue&type=template&id=42845a30"
import script from "./SelectInputFilter.vue?vue&type=script&lang=js"
export * from "./SelectInputFilter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\coreme\\suporte\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__